import { api } from './api';

export const emailService = {
    // Basic email operations
    fetchEmails: (page = 1, limit = 20) => api.get(`/emails?page=${page}&limit=${limit}`),
    fetchEmail: (id) => api.get(`/emails/${id}`),
    sendEmail: (data) => api.post('/emails/send', data),
    deleteEmail: (id) => api.delete(`/emails/${id}`),

    // Local storage placeholders
    getSentEmails: () => [],
    getDrafts: () => [],
    getTrashEmails: () => []
};